import { FETCH_LOV_REQUEST, FETCH_LOV_SUCCESS, FETCH_LOV_FAILURE } from "./LOVTypes";

const initialState = {
  loading: false,
  lovDataByBaseUrl: {}, 
  error: "",
};


const lovReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LOV_REQUEST:
      return { ...state, loading: true };

    case FETCH_LOV_SUCCESS:
      return {
        ...state,
        loading: false,
        lovDataByBaseUrl: {
          ...state.lovDataByBaseUrl,
          [action.baseUrl]: action.payload,  // Store by baseUrl
        },
        error: "",
      };

    case FETCH_LOV_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default lovReducer;

